// extracted by mini-css-extract-plugin
export default {"collLayerSelect":"index_collLayerSelect__XAP6G","collLayerLabelValue":"index_collLayerLabelValue__MhizM"};